import capitalize from 'lodash/capitalize';
import { NextPage } from 'next';
import React from 'react';

import useHasAccountAccess from '@jpp/hooks/useHasAccountAccess';
import { EMyAccountTab } from '@jpp/organisms/MyAccount/TabGroup/MyAccountTabGroup';
import PageHandler from '@jpp/shared/PageHandler';
import MyAccount from '@jpp/templates/MyAccount';
import { EPageType } from 'common/typings/enums';
import { getQueryParamFirstValue } from 'common/utils/shared/route';

interface IMyAccountPages {
  slug?: string;
}

const MyAccountPages: NextPage<IMyAccountPages> = ({ slug: serverSlug }) => {
  useHasAccountAccess();
  const slug = getQueryParamFirstValue<string, EMyAccountTab>(serverSlug);
  return (
    <PageHandler
      page={{ title: `${capitalize(slug)} | My Account` }}
      pageType={EPageType.MyAccount}
      template={MyAccount}
    />
  );
};

MyAccountPages.getInitialProps = ({ query }) => {
  const slug = getQueryParamFirstValue(query.slug) as EMyAccountTab;
  const myAccountPages = Object.values(EMyAccountTab);
  const isValidSlug = myAccountPages.includes(slug);
  return {
    slug: isValidSlug ? slug : EMyAccountTab.Details,
  };
};

export default MyAccountPages;
